(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fairnatural-glp1-vegan"] && !Shopify.designMode) return;
  try {
    

(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-fnq-config]').textContent);
    root.querySelectorAll('[data-product-tabs]').forEach(group=>{
      const list=group.querySelector('[role="tablist"]'),tabs=[...list.querySelectorAll('[role="tab"]')],panels=[...group.querySelectorAll('[role="tabpanel"]')];
      const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index||(index===-1&&i===0)?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();};
      list.hidden=false;group.classList.add('fnq-tabs-ready');activate(-1);
      tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab.getAttribute('aria-selected')==='true'?-1:index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activate(next,true);});});
    });
    const timers=[];
    const linkSelector='a[href]:not([data-fnq-lab]):not([data-fnq-legal])';
    const filterLink=link=>{const href=link.getAttribute('href');if(!href||href.startsWith('#'))return;try{const url=new URL(href,window.location.href);if(url.origin===window.location.origin&&/\/policies\//.test(url.pathname))return;}catch{}link.removeAttribute('href');};
    const stripOutbound=node=>{if(node.nodeType!==1)return;if(node.matches(linkSelector))filterLink(node);node.querySelectorAll(linkSelector).forEach(filterLink);};
    stripOutbound(root);
    const linkObserver=new MutationObserver(records=>{for(const record of records){if(record.type==='attributes'){if(record.target.matches(linkSelector))filterLink(record.target);}else{record.addedNodes.forEach(stripOutbound);}}});
    linkObserver.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    root.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',async()=>{const drawer=document.querySelector('cart-drawer');try{if(drawer?.handleCartOpen)await drawer.handleCartOpen({scrollToTop:true});else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});}catch{button.textContent=config.messages.drawerError;}}));
    root.querySelectorAll('[data-deadline]').forEach(node=>{
      const repeating=node.dataset.timerMode==='repeat';
      const raw=(repeating?node.dataset.cycleAnchor:node.dataset.deadline).trim();
      const end=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)?Date.parse(raw):NaN;
      const duration=Number(node.dataset.cycleHours)*3600000;
      if(!Number.isFinite(end)||(repeating&&(!Number.isFinite(duration)||duration<=0))){const warning=node.parentElement.querySelector('[data-deadline-invalid]');if(warning)warning.hidden=false;return;}
      node.hidden=false;
      const clockNodes=Object.fromEntries(['days','hours','minutes','seconds'].map(key=>[key,node.querySelector('[data-clock-'+key+']')]));
      const tick=()=>{
        const now=Date.now();
        const cycleEnd=repeating?(now<end?end:end+(Math.floor((now-end)/duration)+1)*duration):end;
        const remaining=Math.max(0,Math.ceil((cycleEnd-now)/1000));
        if(!remaining){node.textContent=node.dataset.ended;return false;}
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>{const text=String(value).padStart(2,'0'),cell=clockNodes[key];if(cell.textContent!==text)cell.textContent=text;});
        return true;
      };
      if(tick()){const timer=setInterval(()=>{if(!document.hidden&&!tick())clearInterval(timer);},1000);timers.push(timer);}
    });
    root._fnqCleanup=()=>{timers.forEach(clearInterval);linkObserver.disconnect();};
    root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
      const img=root.querySelector('.fnq-main-image img');
      if(!img)return;
      img.srcset=button.dataset.gallerySrcset||'';img.src=button.dataset.gallerySrc;img.alt=button.dataset.galleryAlt||config.handle;
      root.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
    async function addItem(item){
      const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer'],sections_url:window.location.pathname})});
      let payload;try{payload=await response.json();}catch{throw new Error(config.messages.error);}
      if(!response.ok)throw new Error(typeof payload.description==='string'?payload.description:config.messages.error);
      try{
        const drawer=document.querySelector('cart-drawer');
        if(!drawer)throw new Error('Drawer unavailable');
        if(payload.sections?.['cart-drawer']&&typeof drawer.handleCartUpdate==='function')await drawer.handleCartUpdate(payload);
        else if(typeof drawer.handleCartRender==='function')await drawer.handleCartRender();
        else throw new Error('Drawer rendering unavailable');
        if(typeof drawer.handleCartOpen==='function')await drawer.handleCartOpen({scrollToTop:true});
        else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});
        else throw new Error('Drawer opening unavailable');
        const res=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(res.ok)window.wetheme?.updateCartCount?.(await res.json());
        return true;
      }catch{return false;}
    }
    root.querySelectorAll('[data-recommend-form]').forEach(rec=>{
      let pending=false;
      const recSelect=rec.querySelector('[data-recommend-variant]');
      recSelect?.addEventListener('change',()=>{
        const option=recSelect.selectedOptions[0];rec.dataset.recommendPrice=option.dataset.recommendAmount;
        const price=rec.closest('article').querySelector('.fnq-recommend-price');
        const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
        price.textContent=money.format(Number(option.dataset.recommendAmount)/100);
        if(Number(option.dataset.recommendCompare)>Number(option.dataset.recommendAmount)){const strike=document.createElement('s');strike.textContent=money.format(Number(option.dataset.recommendCompare)/100);price.append(' ',strike);}
      });
      rec.addEventListener('submit',async event=>{
        event.preventDefault();event.stopImmediatePropagation();if(pending||!rec.reportValidity())return;
        pending=true;const button=rec.querySelector('button[type="submit"]'),status=rec.querySelector('[data-recommend-status]');
        button.disabled=true;status.hidden=false;status.textContent=config.messages.checking;
        try{
          const response=await fetch(base+'products/'+encodeURIComponent(rec.dataset.handle)+'.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw new Error(config.messages.error);
          const product=await response.json(),variant=product.variants.find(v=>String(v.id)===String(rec.elements.namedItem('id').value));
          if(!variant?.available)throw new Error(config.messages.unavailable);
          if(Number(rec.dataset.recommendPrice)!==variant.price)throw new Error(config.messages.priceChanged);
          const opened=await addItem({id:variant.id,quantity:1});
          status.textContent=opened?config.messages.success:config.messages.drawerError;
          rec.querySelector('[data-recommend-cart]').hidden=false;
        }catch(error){status.textContent=error.message||config.messages.error;}
        finally{pending=false;button.disabled=false;}
      },true);
    });
    const form=root.querySelector('.fnq-form');
    if(!form)return;
    const selectors=[...form.querySelectorAll('[data-flavour]')];
    const submits=[...form.querySelectorAll('button[type="submit"]')];
    const status=form.querySelector('[data-status]');
    const success=form.querySelector('[data-success]');
    const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
    const format=cents=>money.format(cents/100);
    let busy=false;
    const current=()=>config.variants.find(v=>String(v.id)===String(form.elements.namedItem('id').value));
    const tell=(message,error=false)=>{status.hidden=false;status.textContent=message;status.dataset.error=String(error);};
    const picture=select=>{const option=select.selectedOptions[0],img=form.querySelector('[data-flavour-image="'+select.dataset.flavour+'"]');if(img&&option?.dataset.image){img.src=option.dataset.image;img.alt=option.value;}};
    const update=()=>{
      const v=current();if(!v)return;
      submits.forEach(button=>button.disabled=busy||!v.available);
      const cartButton=form.querySelector('[data-action="cart"]');cartButton.textContent=v.available?cartButton.dataset.availableLabel:config.messages.soldOut;
      root.querySelectorAll('[data-offer-price]').forEach(el=>el.textContent=format(v.price));
      const discount=(v.compare_at_price||0)-v.price;
      root.querySelectorAll('[data-compare]').forEach(el=>{el.hidden=discount<=0;el.textContent=format(v.compare_at_price||0);});
      root.querySelectorAll('[data-saving]').forEach(el=>el.hidden=discount<=0);
      root.querySelectorAll('[data-saving-amount]').forEach(el=>el.textContent=format(Math.max(0,discount)));
      root.querySelectorAll('[data-portion-price]').forEach(el=>el.textContent=format(Math.round(v.price/config.portions)));
      root.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=format(Math.round(v.price*1000/config.weight)));
      root.querySelectorAll('[data-availability]').forEach(el=>{el.textContent=v.available?el.dataset.yes:el.dataset.no;el.dataset.live=String(v.available);});
    };
    selectors.forEach((select,index)=>{
      const preferred=index===0?'Vanille':'Schokolade';
      const option=[...select.options].find(o=>o.value===preferred&&!o.disabled)||[...select.options].find(o=>o.value&&!o.disabled);
      if(option)select.value=option.value;
      picture(select);
      select.addEventListener('change',()=>{picture(select);status.hidden=true;success.hidden=true;});
    });
    form.querySelector('[data-variant]')?.addEventListener('change',()=>{update();status.hidden=true;success.hidden=true;});
    update();
    async function readProduct(handle){
      const response=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(config.messages.error);
      return response.json();
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      const variant=current();
      if(!variant?.available){tell(config.messages.unavailable,true);return;}
      const chosen=selectors.map(select=>({value:select.value,handle:select.selectedOptions[0]?.dataset.handle}));
      if(config.bundle&&(chosen.length!==2||chosen.some(x=>!x.value||!x.handle))){tell(config.messages.unavailable,true);return;}
      busy=true;submits.forEach(button=>button.disabled=true);success.hidden=true;tell(config.messages.checking);
      try{
        const handles=[...new Set([config.handle,...chosen.map(x=>x.handle)])];
        const products=await Promise.all(handles.map(readProduct));
        const byHandle=Object.fromEntries(handles.map((handle,index)=>[handle,products[index]]));
        const liveVariant=byHandle[config.handle].variants.find(v=>String(v.id)===String(variant.id));
        if(!liveVariant?.available){variant.available=false;throw new Error(config.messages.unavailable);}
        if(liveVariant.price!==variant.price)throw new Error(config.messages.priceChanged);
        const unavailable=chosen.filter(x=>!byHandle[x.handle]?.available);
        if(unavailable.length){
          unavailable.forEach(x=>selectors.forEach(select=>[...select.options].filter(o=>o.dataset.handle===x.handle).forEach(o=>o.disabled=true)));
          selectors.forEach(select=>{if(select.selectedOptions[0]?.disabled){select.value='';picture(select);}});
          throw new Error(config.messages.unavailable);
        }
        const item={id:variant.id,quantity:1};
        if(config.bundle)item.properties={'1. Protein Geschmack':chosen[0].value,'2. Protein Geschmack':chosen[1].value};
        const opened=await addItem(item);
        tell(opened?config.messages.success:config.messages.drawerError);success.hidden=false;
        status.focus();
      }catch(error){tell(error.message||config.messages.error,true);status.focus();}
      finally{busy=false;update();}
    },true);
  }
  const boot=(scope=document)=>scope.querySelectorAll('[data-fnq]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fnq]').forEach(root=>root._fnqCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fairnatural-glp1-whey"] && !Shopify.designMode) return;
  try {
    

(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-fnq-config]').textContent);
    root.querySelectorAll('[data-product-tabs]').forEach(group=>{
      const list=group.querySelector('[role="tablist"]'),tabs=[...list.querySelectorAll('[role="tab"]')],panels=[...group.querySelectorAll('[role="tabpanel"]')];
      const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index||(index===-1&&i===0)?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();};
      list.hidden=false;group.classList.add('fnq-tabs-ready');activate(-1);
      tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab.getAttribute('aria-selected')==='true'?-1:index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activate(next,true);});});
    });
    const timers=[];
    const linkSelector='a[href]:not([data-fnq-lab]):not([data-fnq-legal])';
    const filterLink=link=>{const href=link.getAttribute('href');if(!href||href.startsWith('#'))return;try{const url=new URL(href,window.location.href);if(url.origin===window.location.origin&&/\/policies\//.test(url.pathname))return;}catch{}link.removeAttribute('href');};
    const stripOutbound=node=>{if(node.nodeType!==1)return;if(node.matches(linkSelector))filterLink(node);node.querySelectorAll(linkSelector).forEach(filterLink);};
    stripOutbound(root);
    const linkObserver=new MutationObserver(records=>{for(const record of records){if(record.type==='attributes'){if(record.target.matches(linkSelector))filterLink(record.target);}else{record.addedNodes.forEach(stripOutbound);}}});
    linkObserver.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    root.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',async()=>{const drawer=document.querySelector('cart-drawer');try{if(drawer?.handleCartOpen)await drawer.handleCartOpen({scrollToTop:true});else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});}catch{button.textContent=config.messages.drawerError;}}));
    root.querySelectorAll('[data-deadline]').forEach(node=>{
      const repeating=node.dataset.timerMode==='repeat';
      const raw=(repeating?node.dataset.cycleAnchor:node.dataset.deadline).trim();
      const end=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)?Date.parse(raw):NaN;
      const duration=Number(node.dataset.cycleHours)*3600000;
      if(!Number.isFinite(end)||(repeating&&(!Number.isFinite(duration)||duration<=0))){const warning=node.parentElement.querySelector('[data-deadline-invalid]');if(warning)warning.hidden=false;return;}
      node.hidden=false;
      const clockNodes=Object.fromEntries(['days','hours','minutes','seconds'].map(key=>[key,node.querySelector('[data-clock-'+key+']')]));
      const tick=()=>{
        const now=Date.now();
        const cycleEnd=repeating?(now<end?end:end+(Math.floor((now-end)/duration)+1)*duration):end;
        const remaining=Math.max(0,Math.ceil((cycleEnd-now)/1000));
        if(!remaining){node.textContent=node.dataset.ended;return false;}
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>{const text=String(value).padStart(2,'0'),cell=clockNodes[key];if(cell.textContent!==text)cell.textContent=text;});
        return true;
      };
      if(tick()){const timer=setInterval(()=>{if(!document.hidden&&!tick())clearInterval(timer);},1000);timers.push(timer);}
    });
    root._fnqCleanup=()=>{timers.forEach(clearInterval);linkObserver.disconnect();};
    root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
      const img=root.querySelector('.fnq-main-image img');
      if(!img)return;
      img.srcset=button.dataset.gallerySrcset||'';img.src=button.dataset.gallerySrc;img.alt=button.dataset.galleryAlt||config.handle;
      root.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
    async function addItem(item){
      const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer'],sections_url:window.location.pathname})});
      let payload;try{payload=await response.json();}catch{throw new Error(config.messages.error);}
      if(!response.ok)throw new Error(typeof payload.description==='string'?payload.description:config.messages.error);
      try{
        const drawer=document.querySelector('cart-drawer');
        if(!drawer)throw new Error('Drawer unavailable');
        if(payload.sections?.['cart-drawer']&&typeof drawer.handleCartUpdate==='function')await drawer.handleCartUpdate(payload);
        else if(typeof drawer.handleCartRender==='function')await drawer.handleCartRender();
        else throw new Error('Drawer rendering unavailable');
        if(typeof drawer.handleCartOpen==='function')await drawer.handleCartOpen({scrollToTop:true});
        else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});
        else throw new Error('Drawer opening unavailable');
        const res=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(res.ok)window.wetheme?.updateCartCount?.(await res.json());
        return true;
      }catch{return false;}
    }
    root.querySelectorAll('[data-recommend-form]').forEach(rec=>{
      let pending=false;
      const recSelect=rec.querySelector('[data-recommend-variant]');
      recSelect?.addEventListener('change',()=>{
        const option=recSelect.selectedOptions[0];rec.dataset.recommendPrice=option.dataset.recommendAmount;
        const price=rec.closest('article').querySelector('.fnq-recommend-price');
        const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
        price.textContent=money.format(Number(option.dataset.recommendAmount)/100);
        if(Number(option.dataset.recommendCompare)>Number(option.dataset.recommendAmount)){const strike=document.createElement('s');strike.textContent=money.format(Number(option.dataset.recommendCompare)/100);price.append(' ',strike);}
      });
      rec.addEventListener('submit',async event=>{
        event.preventDefault();event.stopImmediatePropagation();if(pending||!rec.reportValidity())return;
        pending=true;const button=rec.querySelector('button[type="submit"]'),status=rec.querySelector('[data-recommend-status]');
        button.disabled=true;status.hidden=false;status.textContent=config.messages.checking;
        try{
          const response=await fetch(base+'products/'+encodeURIComponent(rec.dataset.handle)+'.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw new Error(config.messages.error);
          const product=await response.json(),variant=product.variants.find(v=>String(v.id)===String(rec.elements.namedItem('id').value));
          if(!variant?.available)throw new Error(config.messages.unavailable);
          if(Number(rec.dataset.recommendPrice)!==variant.price)throw new Error(config.messages.priceChanged);
          const opened=await addItem({id:variant.id,quantity:1});
          status.textContent=opened?config.messages.success:config.messages.drawerError;
          rec.querySelector('[data-recommend-cart]').hidden=false;
        }catch(error){status.textContent=error.message||config.messages.error;}
        finally{pending=false;button.disabled=false;}
      },true);
    });
    const form=root.querySelector('.fnq-form');
    if(!form)return;
    const selectors=[...form.querySelectorAll('[data-flavour]')];
    const submits=[...form.querySelectorAll('button[type="submit"]')];
    const status=form.querySelector('[data-status]');
    const success=form.querySelector('[data-success]');
    const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
    const format=cents=>money.format(cents/100);
    let busy=false;
    const current=()=>config.variants.find(v=>String(v.id)===String(form.elements.namedItem('id').value));
    const tell=(message,error=false)=>{status.hidden=false;status.textContent=message;status.dataset.error=String(error);};
    const picture=select=>{const option=select.selectedOptions[0],img=form.querySelector('[data-flavour-image="'+select.dataset.flavour+'"]');if(img&&option?.dataset.image){img.src=option.dataset.image;img.alt=option.value;}};
    const update=()=>{
      const v=current();if(!v)return;
      submits.forEach(button=>button.disabled=busy||!v.available);
      const cartButton=form.querySelector('[data-action="cart"]');cartButton.textContent=v.available?cartButton.dataset.availableLabel:config.messages.soldOut;
      root.querySelectorAll('[data-offer-price]').forEach(el=>el.textContent=format(v.price));
      const discount=(v.compare_at_price||0)-v.price;
      root.querySelectorAll('[data-compare]').forEach(el=>{el.hidden=discount<=0;el.textContent=format(v.compare_at_price||0);});
      root.querySelectorAll('[data-saving]').forEach(el=>el.hidden=discount<=0);
      root.querySelectorAll('[data-saving-amount]').forEach(el=>el.textContent=format(Math.max(0,discount)));
      root.querySelectorAll('[data-portion-price]').forEach(el=>el.textContent=format(Math.round(v.price/config.portions)));
      root.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=format(Math.round(v.price*1000/config.weight)));
      root.querySelectorAll('[data-availability]').forEach(el=>{el.textContent=v.available?el.dataset.yes:el.dataset.no;el.dataset.live=String(v.available);});
    };
    selectors.forEach((select,index)=>{
      const preferred=index===0?'Vanille':'Schokolade';
      const option=[...select.options].find(o=>o.value===preferred&&!o.disabled)||[...select.options].find(o=>o.value&&!o.disabled);
      if(option)select.value=option.value;
      picture(select);
      select.addEventListener('change',()=>{picture(select);status.hidden=true;success.hidden=true;});
    });
    form.querySelector('[data-variant]')?.addEventListener('change',()=>{update();status.hidden=true;success.hidden=true;});
    update();
    async function readProduct(handle){
      const response=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(config.messages.error);
      return response.json();
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      const variant=current();
      if(!variant?.available){tell(config.messages.unavailable,true);return;}
      const chosen=selectors.map(select=>({value:select.value,handle:select.selectedOptions[0]?.dataset.handle}));
      if(config.bundle&&(chosen.length!==2||chosen.some(x=>!x.value||!x.handle))){tell(config.messages.unavailable,true);return;}
      busy=true;submits.forEach(button=>button.disabled=true);success.hidden=true;tell(config.messages.checking);
      try{
        const handles=[...new Set([config.handle,...chosen.map(x=>x.handle)])];
        const products=await Promise.all(handles.map(readProduct));
        const byHandle=Object.fromEntries(handles.map((handle,index)=>[handle,products[index]]));
        const liveVariant=byHandle[config.handle].variants.find(v=>String(v.id)===String(variant.id));
        if(!liveVariant?.available){variant.available=false;throw new Error(config.messages.unavailable);}
        if(liveVariant.price!==variant.price)throw new Error(config.messages.priceChanged);
        const unavailable=chosen.filter(x=>!byHandle[x.handle]?.available);
        if(unavailable.length){
          unavailable.forEach(x=>selectors.forEach(select=>[...select.options].filter(o=>o.dataset.handle===x.handle).forEach(o=>o.disabled=true)));
          selectors.forEach(select=>{if(select.selectedOptions[0]?.disabled){select.value='';picture(select);}});
          throw new Error(config.messages.unavailable);
        }
        const item={id:variant.id,quantity:1};
        if(config.bundle)item.properties={'1. Protein Geschmack':chosen[0].value,'2. Protein Geschmack':chosen[1].value};
        const opened=await addItem(item);
        tell(opened?config.messages.success:config.messages.drawerError);success.hidden=false;
        status.focus();
      }catch(error){tell(error.message||config.messages.error,true);status.focus();}
      finally{busy=false;update();}
    },true);
  }
  const boot=(scope=document)=>scope.querySelectorAll('[data-fnq]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fnq]').forEach(root=>root._fnqCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fairnatural-q4"] && !Shopify.designMode) return;
  try {
    

(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-fnq-config]').textContent);
    root.querySelectorAll('[data-product-tabs]').forEach(group=>{
      const list=group.querySelector('[role="tablist"]'),tabs=[...list.querySelectorAll('[role="tab"]')],panels=[...group.querySelectorAll('[role="tabpanel"]')];
      const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index||(index===-1&&i===0)?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();};
      list.hidden=false;group.classList.add('fnq-tabs-ready');activate(-1);
      tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab.getAttribute('aria-selected')==='true'?-1:index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activate(next,true);});});
    });
    const timers=[];
    const linkSelector='a[href]:not([data-fnq-lab]):not([data-fnq-legal])';
    const filterLink=link=>{const href=link.getAttribute('href');if(!href||href.startsWith('#'))return;try{const url=new URL(href,window.location.href);if(url.origin===window.location.origin&&/\/policies\//.test(url.pathname))return;}catch{}link.removeAttribute('href');};
    const stripOutbound=node=>{if(node.nodeType!==1)return;if(node.matches(linkSelector))filterLink(node);node.querySelectorAll(linkSelector).forEach(filterLink);};
    stripOutbound(root);
    const linkObserver=new MutationObserver(records=>{for(const record of records){if(record.type==='attributes'){if(record.target.matches(linkSelector))filterLink(record.target);}else{record.addedNodes.forEach(stripOutbound);}}});
    linkObserver.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    root.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',async()=>{const drawer=document.querySelector('cart-drawer');try{if(drawer?.handleCartOpen)await drawer.handleCartOpen({scrollToTop:true});else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});}catch{button.textContent=config.messages.drawerError;}}));
    root.querySelectorAll('[data-deadline]').forEach(node=>{
      const repeating=node.dataset.timerMode==='repeat';
      const raw=(repeating?node.dataset.cycleAnchor:node.dataset.deadline).trim();
      const end=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)?Date.parse(raw):NaN;
      const duration=Number(node.dataset.cycleHours)*3600000;
      if(!Number.isFinite(end)||(repeating&&(!Number.isFinite(duration)||duration<=0))){const warning=node.parentElement.querySelector('[data-deadline-invalid]');if(warning)warning.hidden=false;return;}
      node.hidden=false;
      const clockNodes=Object.fromEntries(['days','hours','minutes','seconds'].map(key=>[key,node.querySelector('[data-clock-'+key+']')]));
      const tick=()=>{
        const now=Date.now();
        const cycleEnd=repeating?(now<end?end:end+(Math.floor((now-end)/duration)+1)*duration):end;
        const remaining=Math.max(0,Math.ceil((cycleEnd-now)/1000));
        if(!remaining){node.textContent=node.dataset.ended;return false;}
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>{const text=String(value).padStart(2,'0'),cell=clockNodes[key];if(cell.textContent!==text)cell.textContent=text;});
        return true;
      };
      if(tick()){const timer=setInterval(()=>{if(!document.hidden&&!tick())clearInterval(timer);},1000);timers.push(timer);}
    });
    root._fnqCleanup=()=>{timers.forEach(clearInterval);linkObserver.disconnect();};
    root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
      const img=root.querySelector('.fnq-main-image img');
      if(!img)return;
      img.srcset=button.dataset.gallerySrcset||'';img.src=button.dataset.gallerySrc;img.alt=button.dataset.galleryAlt||config.handle;
      root.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
    async function addItem(item){
      const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer'],sections_url:window.location.pathname})});
      let payload;try{payload=await response.json();}catch{throw new Error(config.messages.error);}
      if(!response.ok)throw new Error(typeof payload.description==='string'?payload.description:config.messages.error);
      try{
        const drawer=document.querySelector('cart-drawer');
        if(!drawer)throw new Error('Drawer unavailable');
        if(payload.sections?.['cart-drawer']&&typeof drawer.handleCartUpdate==='function')await drawer.handleCartUpdate(payload);
        else if(typeof drawer.handleCartRender==='function')await drawer.handleCartRender();
        else throw new Error('Drawer rendering unavailable');
        if(typeof drawer.handleCartOpen==='function')await drawer.handleCartOpen({scrollToTop:true});
        else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});
        else throw new Error('Drawer opening unavailable');
        const res=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(res.ok)window.wetheme?.updateCartCount?.(await res.json());
        return true;
      }catch{return false;}
    }
    root.querySelectorAll('[data-recommend-form]').forEach(rec=>{
      let pending=false;
      const recSelect=rec.querySelector('[data-recommend-variant]');
      recSelect?.addEventListener('change',()=>{
        const option=recSelect.selectedOptions[0];rec.dataset.recommendPrice=option.dataset.recommendAmount;
        const price=rec.closest('article').querySelector('.fnq-recommend-price');
        const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
        price.textContent=money.format(Number(option.dataset.recommendAmount)/100);
        if(Number(option.dataset.recommendCompare)>Number(option.dataset.recommendAmount)){const strike=document.createElement('s');strike.textContent=money.format(Number(option.dataset.recommendCompare)/100);price.append(' ',strike);}
      });
      rec.addEventListener('submit',async event=>{
        event.preventDefault();event.stopImmediatePropagation();if(pending||!rec.reportValidity())return;
        pending=true;const button=rec.querySelector('button[type="submit"]'),status=rec.querySelector('[data-recommend-status]');
        button.disabled=true;status.hidden=false;status.textContent=config.messages.checking;
        try{
          const response=await fetch(base+'products/'+encodeURIComponent(rec.dataset.handle)+'.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw new Error(config.messages.error);
          const product=await response.json(),variant=product.variants.find(v=>String(v.id)===String(rec.elements.namedItem('id').value));
          if(!variant?.available)throw new Error(config.messages.unavailable);
          if(Number(rec.dataset.recommendPrice)!==variant.price)throw new Error(config.messages.priceChanged);
          const opened=await addItem({id:variant.id,quantity:1});
          status.textContent=opened?config.messages.success:config.messages.drawerError;
          rec.querySelector('[data-recommend-cart]').hidden=false;
        }catch(error){status.textContent=error.message||config.messages.error;}
        finally{pending=false;button.disabled=false;}
      },true);
    });
    const form=root.querySelector('.fnq-form');
    if(!form)return;
    const selectors=[...form.querySelectorAll('[data-flavour]')];
    const submits=[...form.querySelectorAll('button[type="submit"]')];
    const status=form.querySelector('[data-status]');
    const success=form.querySelector('[data-success]');
    const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
    const format=cents=>money.format(cents/100);
    let busy=false;
    const current=()=>config.variants.find(v=>String(v.id)===String(form.elements.namedItem('id').value));
    const tell=(message,error=false)=>{status.hidden=false;status.textContent=message;status.dataset.error=String(error);};
    const picture=select=>{const option=select.selectedOptions[0],img=form.querySelector('[data-flavour-image="'+select.dataset.flavour+'"]');if(img&&option?.dataset.image){img.src=option.dataset.image;img.alt=option.value;}};
    const update=()=>{
      const v=current();if(!v)return;
      submits.forEach(button=>button.disabled=busy||!v.available);
      const cartButton=form.querySelector('[data-action="cart"]');cartButton.textContent=v.available?cartButton.dataset.availableLabel:config.messages.soldOut;
      root.querySelectorAll('[data-offer-price]').forEach(el=>el.textContent=format(v.price));
      const discount=(v.compare_at_price||0)-v.price;
      root.querySelectorAll('[data-compare]').forEach(el=>{el.hidden=discount<=0;el.textContent=format(v.compare_at_price||0);});
      root.querySelectorAll('[data-saving]').forEach(el=>el.hidden=discount<=0);
      root.querySelectorAll('[data-saving-amount]').forEach(el=>el.textContent=format(Math.max(0,discount)));
      root.querySelectorAll('[data-portion-price]').forEach(el=>el.textContent=format(Math.round(v.price/config.portions)));
      root.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=format(Math.round(v.price*1000/config.weight)));
      root.querySelectorAll('[data-availability]').forEach(el=>{el.textContent=v.available?el.dataset.yes:el.dataset.no;el.dataset.live=String(v.available);});
    };
    selectors.forEach((select,index)=>{
      const preferred=index===0?'Vanille':'Schokolade';
      const option=[...select.options].find(o=>o.value===preferred&&!o.disabled)||[...select.options].find(o=>o.value&&!o.disabled);
      if(option)select.value=option.value;
      picture(select);
      select.addEventListener('change',()=>{picture(select);status.hidden=true;success.hidden=true;});
    });
    form.querySelector('[data-variant]')?.addEventListener('change',()=>{update();status.hidden=true;success.hidden=true;});
    update();
    async function readProduct(handle){
      const response=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(config.messages.error);
      return response.json();
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      const variant=current();
      if(!variant?.available){tell(config.messages.unavailable,true);return;}
      const chosen=selectors.map(select=>({value:select.value,handle:select.selectedOptions[0]?.dataset.handle}));
      if(config.bundle&&(chosen.length!==2||chosen.some(x=>!x.value||!x.handle))){tell(config.messages.unavailable,true);return;}
      busy=true;submits.forEach(button=>button.disabled=true);success.hidden=true;tell(config.messages.checking);
      try{
        const handles=[...new Set([config.handle,...chosen.map(x=>x.handle)])];
        const products=await Promise.all(handles.map(readProduct));
        const byHandle=Object.fromEntries(handles.map((handle,index)=>[handle,products[index]]));
        const liveVariant=byHandle[config.handle].variants.find(v=>String(v.id)===String(variant.id));
        if(!liveVariant?.available){variant.available=false;throw new Error(config.messages.unavailable);}
        if(liveVariant.price!==variant.price)throw new Error(config.messages.priceChanged);
        const unavailable=chosen.filter(x=>!byHandle[x.handle]?.available);
        if(unavailable.length){
          unavailable.forEach(x=>selectors.forEach(select=>[...select.options].filter(o=>o.dataset.handle===x.handle).forEach(o=>o.disabled=true)));
          selectors.forEach(select=>{if(select.selectedOptions[0]?.disabled){select.value='';picture(select);}});
          throw new Error(config.messages.unavailable);
        }
        const item={id:variant.id,quantity:1};
        if(config.bundle)item.properties={'1. Protein Geschmack':chosen[0].value,'2. Protein Geschmack':chosen[1].value};
        const opened=await addItem(item);
        tell(opened?config.messages.success:config.messages.drawerError);success.hidden=false;
        status.focus();
      }catch(error){tell(error.message||config.messages.error,true);status.focus();}
      finally{busy=false;update();}
    },true);
  }
  const boot=(scope=document)=>scope.querySelectorAll('[data-fnq]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fnq]').forEach(root=>root._fnqCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fairnatural-whey"] && !Shopify.designMode) return;
  try {
    

(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const config=JSON.parse(root.querySelector('[data-fnq-config]').textContent);
    root.querySelectorAll('[data-product-tabs]').forEach(group=>{
      const list=group.querySelector('[role="tablist"]'),tabs=[...list.querySelectorAll('[role="tab"]')],panels=[...group.querySelectorAll('[role="tabpanel"]')];
      const activate=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index||(index===-1&&i===0)?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();};
      list.hidden=false;group.classList.add('fnq-tabs-ready');activate(-1);
      tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab.getAttribute('aria-selected')==='true'?-1:index));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();activate(next,true);});});
    });
    const timers=[];
    const linkSelector='a[href]:not([data-fnq-lab]):not([data-fnq-legal])';
    const filterLink=link=>{const href=link.getAttribute('href');if(!href||href.startsWith('#'))return;try{const url=new URL(href,window.location.href);if(url.origin===window.location.origin&&/\/policies\//.test(url.pathname))return;}catch{}link.removeAttribute('href');};
    const stripOutbound=node=>{if(node.nodeType!==1)return;if(node.matches(linkSelector))filterLink(node);node.querySelectorAll(linkSelector).forEach(filterLink);};
    stripOutbound(root);
    const linkObserver=new MutationObserver(records=>{for(const record of records){if(record.type==='attributes'){if(record.target.matches(linkSelector))filterLink(record.target);}else{record.addedNodes.forEach(stripOutbound);}}});
    linkObserver.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    root.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',async()=>{const drawer=document.querySelector('cart-drawer');try{if(drawer?.handleCartOpen)await drawer.handleCartOpen({scrollToTop:true});else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});}catch{button.textContent=config.messages.drawerError;}}));
    root.querySelectorAll('[data-deadline]').forEach(node=>{
      const repeating=node.dataset.timerMode==='repeat';
      const raw=(repeating?node.dataset.cycleAnchor:node.dataset.deadline).trim();
      const end=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)?Date.parse(raw):NaN;
      const duration=Number(node.dataset.cycleHours)*3600000;
      if(!Number.isFinite(end)||(repeating&&(!Number.isFinite(duration)||duration<=0))){const warning=node.parentElement.querySelector('[data-deadline-invalid]');if(warning)warning.hidden=false;return;}
      node.hidden=false;
      const clockNodes=Object.fromEntries(['days','hours','minutes','seconds'].map(key=>[key,node.querySelector('[data-clock-'+key+']')]));
      const tick=()=>{
        const now=Date.now();
        const cycleEnd=repeating?(now<end?end:end+(Math.floor((now-end)/duration)+1)*duration):end;
        const remaining=Math.max(0,Math.ceil((cycleEnd-now)/1000));
        if(!remaining){node.textContent=node.dataset.ended;return false;}
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>{const text=String(value).padStart(2,'0'),cell=clockNodes[key];if(cell.textContent!==text)cell.textContent=text;});
        return true;
      };
      if(tick()){const timer=setInterval(()=>{if(!document.hidden&&!tick())clearInterval(timer);},1000);timers.push(timer);}
    });
    root._fnqCleanup=()=>{timers.forEach(clearInterval);linkObserver.disconnect();};
    root.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
      const img=root.querySelector('.fnq-main-image img');
      if(!img)return;
      img.srcset=button.dataset.gallerySrcset||'';img.src=button.dataset.gallerySrc;img.alt=button.dataset.galleryAlt||config.handle;
      root.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    const base=root.dataset.root.endsWith('/')?root.dataset.root:root.dataset.root+'/';
    async function addItem(item){
      const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item],sections:['cart-drawer'],sections_url:window.location.pathname})});
      let payload;try{payload=await response.json();}catch{throw new Error(config.messages.error);}
      if(!response.ok)throw new Error(typeof payload.description==='string'?payload.description:config.messages.error);
      try{
        const drawer=document.querySelector('cart-drawer');
        if(!drawer)throw new Error('Drawer unavailable');
        if(payload.sections?.['cart-drawer']&&typeof drawer.handleCartUpdate==='function')await drawer.handleCartUpdate(payload);
        else if(typeof drawer.handleCartRender==='function')await drawer.handleCartRender();
        else throw new Error('Drawer rendering unavailable');
        if(typeof drawer.handleCartOpen==='function')await drawer.handleCartOpen({scrollToTop:true});
        else if(window.eventBus?.emit)window.eventBus.emit('open:cart:drawer',{scrollToTop:true});
        else throw new Error('Drawer opening unavailable');
        const res=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store'});
        if(res.ok)window.wetheme?.updateCartCount?.(await res.json());
        return true;
      }catch{return false;}
    }
    root.querySelectorAll('[data-recommend-form]').forEach(rec=>{
      let pending=false;
      const recSelect=rec.querySelector('[data-recommend-variant]');
      recSelect?.addEventListener('change',()=>{
        const option=recSelect.selectedOptions[0];rec.dataset.recommendPrice=option.dataset.recommendAmount;
        const price=rec.closest('article').querySelector('.fnq-recommend-price');
        const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
        price.textContent=money.format(Number(option.dataset.recommendAmount)/100);
        if(Number(option.dataset.recommendCompare)>Number(option.dataset.recommendAmount)){const strike=document.createElement('s');strike.textContent=money.format(Number(option.dataset.recommendCompare)/100);price.append(' ',strike);}
      });
      rec.addEventListener('submit',async event=>{
        event.preventDefault();event.stopImmediatePropagation();if(pending||!rec.reportValidity())return;
        pending=true;const button=rec.querySelector('button[type="submit"]'),status=rec.querySelector('[data-recommend-status]');
        button.disabled=true;status.hidden=false;status.textContent=config.messages.checking;
        try{
          const response=await fetch(base+'products/'+encodeURIComponent(rec.dataset.handle)+'.js',{credentials:'same-origin',cache:'no-store'});
          if(!response.ok)throw new Error(config.messages.error);
          const product=await response.json(),variant=product.variants.find(v=>String(v.id)===String(rec.elements.namedItem('id').value));
          if(!variant?.available)throw new Error(config.messages.unavailable);
          if(Number(rec.dataset.recommendPrice)!==variant.price)throw new Error(config.messages.priceChanged);
          const opened=await addItem({id:variant.id,quantity:1});
          status.textContent=opened?config.messages.success:config.messages.drawerError;
          rec.querySelector('[data-recommend-cart]').hidden=false;
        }catch(error){status.textContent=error.message||config.messages.error;}
        finally{pending=false;button.disabled=false;}
      },true);
    });
    const form=root.querySelector('.fnq-form');
    if(!form)return;
    const selectors=[...form.querySelectorAll('[data-flavour]')];
    const submits=[...form.querySelectorAll('button[type="submit"]')];
    const status=form.querySelector('[data-status]');
    const success=form.querySelector('[data-success]');
    const money=new Intl.NumberFormat(root.dataset.locale||'de-DE',{style:'currency',currency:root.dataset.currency||'EUR'});
    const format=cents=>money.format(cents/100);
    let busy=false;
    const current=()=>config.variants.find(v=>String(v.id)===String(form.elements.namedItem('id').value));
    const tell=(message,error=false)=>{status.hidden=false;status.textContent=message;status.dataset.error=String(error);};
    const picture=select=>{const option=select.selectedOptions[0],img=form.querySelector('[data-flavour-image="'+select.dataset.flavour+'"]');if(img&&option?.dataset.image){img.src=option.dataset.image;img.alt=option.value;}};
    const update=()=>{
      const v=current();if(!v)return;
      submits.forEach(button=>button.disabled=busy||!v.available);
      const cartButton=form.querySelector('[data-action="cart"]');cartButton.textContent=v.available?cartButton.dataset.availableLabel:config.messages.soldOut;
      root.querySelectorAll('[data-offer-price]').forEach(el=>el.textContent=format(v.price));
      const discount=(v.compare_at_price||0)-v.price;
      root.querySelectorAll('[data-compare]').forEach(el=>{el.hidden=discount<=0;el.textContent=format(v.compare_at_price||0);});
      root.querySelectorAll('[data-saving]').forEach(el=>el.hidden=discount<=0);
      root.querySelectorAll('[data-saving-amount]').forEach(el=>el.textContent=format(Math.max(0,discount)));
      root.querySelectorAll('[data-portion-price]').forEach(el=>el.textContent=format(Math.round(v.price/config.portions)));
      root.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=format(Math.round(v.price*1000/config.weight)));
      root.querySelectorAll('[data-availability]').forEach(el=>{el.textContent=v.available?el.dataset.yes:el.dataset.no;el.dataset.live=String(v.available);});
    };
    selectors.forEach((select,index)=>{
      const preferred=index===0?'Vanille':'Schokolade';
      const option=[...select.options].find(o=>o.value===preferred&&!o.disabled)||[...select.options].find(o=>o.value&&!o.disabled);
      if(option)select.value=option.value;
      picture(select);
      select.addEventListener('change',()=>{picture(select);status.hidden=true;success.hidden=true;});
    });
    form.querySelector('[data-variant]')?.addEventListener('change',()=>{update();status.hidden=true;success.hidden=true;});
    update();
    async function readProduct(handle){
      const response=await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(config.messages.error);
      return response.json();
    }
    form.addEventListener('submit',async event=>{
      event.preventDefault();event.stopImmediatePropagation();
      if(busy||!form.reportValidity())return;
      const variant=current();
      if(!variant?.available){tell(config.messages.unavailable,true);return;}
      const chosen=selectors.map(select=>({value:select.value,handle:select.selectedOptions[0]?.dataset.handle}));
      if(config.bundle&&(chosen.length!==2||chosen.some(x=>!x.value||!x.handle))){tell(config.messages.unavailable,true);return;}
      busy=true;submits.forEach(button=>button.disabled=true);success.hidden=true;tell(config.messages.checking);
      try{
        const handles=[...new Set([config.handle,...chosen.map(x=>x.handle)])];
        const products=await Promise.all(handles.map(readProduct));
        const byHandle=Object.fromEntries(handles.map((handle,index)=>[handle,products[index]]));
        const liveVariant=byHandle[config.handle].variants.find(v=>String(v.id)===String(variant.id));
        if(!liveVariant?.available){variant.available=false;throw new Error(config.messages.unavailable);}
        if(liveVariant.price!==variant.price)throw new Error(config.messages.priceChanged);
        const unavailable=chosen.filter(x=>!byHandle[x.handle]?.available);
        if(unavailable.length){
          unavailable.forEach(x=>selectors.forEach(select=>[...select.options].filter(o=>o.dataset.handle===x.handle).forEach(o=>o.disabled=true)));
          selectors.forEach(select=>{if(select.selectedOptions[0]?.disabled){select.value='';picture(select);}});
          throw new Error(config.messages.unavailable);
        }
        const item={id:variant.id,quantity:1};
        if(config.bundle)item.properties={'1. Protein Geschmack':chosen[0].value,'2. Protein Geschmack':chosen[1].value};
        const opened=await addItem(item);
        tell(opened?config.messages.success:config.messages.drawerError);success.hidden=false;
        status.focus();
      }catch(error){tell(error.message||config.messages.error,true);status.focus();}
      finally{busy=false;update();}
    },true);
  }
  const boot=(scope=document)=>scope.querySelectorAll('[data-fnq]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fnq]').forEach(root=>root._fnqCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();
})();
